import { render, staticRenderFns } from "./subjectList.vue?vue&type=template&id=595256be&scoped=true"
import script from "./subjectList.vue?vue&type=script&lang=js"
export * from "./subjectList.vue?vue&type=script&lang=js"
import style0 from "./subjectList.vue?vue&type=style&index=0&id=595256be&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595256be",
  null
  
)

export default component.exports